import { ChartBarIcon } from '@heroicons/react/24/outline'
import { useApplications } from '../hooks/useApplications'
import { SankeySection } from './SankeySection'
import { StatsSection } from './dashboard/StatsSection'
import { PageLayout } from './PageLayout'

export function AnalyticsPage() {
  const { sankeyData, depthStats, isLoadingApps, effectivePlan, analyticsStatItems, isPro } = useApplications()

  return (
    <PageLayout
      icon={ChartBarIcon}
      title="Analytics"
      subtitle="Visualize your job search progress and application flow"
    >
      <StatsSection statItems={analyticsStatItems} isLoadingApps={isLoadingApps} isPro={isPro} />

      <SankeySection
        sankeyData={sankeyData}
        depthStats={depthStats}
        isLoading={isLoadingApps}
        plan={effectivePlan}
      />
    </PageLayout>
  )
}
